<template>
  <div>
    <div v-for="(group, index) in groups" :key="index">
      <recursive-row
        :group="group"
        :searchTerm="searchTerm"
        :level="level"
        :pageType="pageType"
        @searchFound="emitSearchFound"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "RecursiveRows",
  props: {
    groups: Array,
    level: Number,
    searchTerm: String,
    pageType: String
  },
  methods: {
    emitSearchFound(match) {
      this.$emit("searchFound", match);
    }
  }
};
</script>
